// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__EdRhZ","header":"PatientQuestionnaire_header__1hK3Q","info":"PatientQuestionnaire_info__2TPf1"};